var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#9A9A9A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 768,
    transform: "translate(-655 -288)",
    fill: "black",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -148,
    y: -56,
    width: 352,
    height: 304,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0C12.5399 0 0 12.5434 0 28.0078C0 43.4722 12.5243 56 28 56C43.4757 56 56 43.4566 56 27.9922C56 12.5278 43.4601 0 28 0ZM42.9448 22.6031L27.4691 37.4427C26.9225 37.9582 26.2197 38.2237 25.517 38.2237C24.8143 38.2237 24.1116 37.9582 23.565 37.4427L15.8193 30.0229C14.6949 28.9451 14.6637 27.1643 15.7412 26.0396C16.8187 24.9149 18.599 24.8837 19.7234 25.9615L25.517 31.5225L39.0407 18.5417C40.1651 17.4639 41.9453 17.5107 43.0229 18.6198C44.1004 19.7445 44.0692 21.5252 42.9448 22.6031Z",
    fill: "#9157F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawSuccess);
export default __webpack_public_path__ + "static/media/withdraw_success.df0e4d344353c38ec88311ad71a7537c.svg";
export { ForwardRef as ReactComponent };